<div [class]="classList" *ngIf="control">
  <lib-form-label *ngIf="label" [label]="label" [isRequired]="isRequired">
    <i
      *ngIf="tooltip"
      class="bx bx-question-mark font-size-18 mb-0 cursor-pointer text-info"
      [title]="tooltip"
    ></i>
  </lib-form-label>

  <div class="position-relative {{ innerClassList }}">
    <!-- icon inside input -->
    <span
      *ngIf="icon && iconPosition === 'inside'"
      class="position-absolute top-50 translate-middle-y start-0 ms-3"
    >
      <i [class]="icon"></i>
    </span>

    <input
      type="url"
      class="form-control"
      [attr.id]="inputId ? inputId : label"
      [class.ps-5]="icon && iconPosition === 'inside'"
      [class.icon-padding]="icon && iconPosition === 'outside'"
      [class.is-invalid]="control.enabled && control.touched && !control.valid"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [formControl]="control"
      (keydown)="onUrlKeydown($event)"
      (focusout)="onFocusOut()"
      (focus)="focus.emit($event)"
      (blur)="blur.emit($event)"
    />

    <!-- icon outside input (clickable) -->
    <i
      *ngIf="icon && iconPosition === 'outside' && (!control.touched || !control.errors)"
      class="icon-container {{ icon }}"
      [title]="iconTooltip"
      (click)="onIconClick()"
      [class.cursor-pointer]="control.enabled || clickableIconWhenDisabled"
    ></i>

    <app-form-field-error
      *ngIf="control.touched && !control.valid"
      [label]="label"
      [placeholder]="placeholder"
      [errors]="control.errors"
      class="{{ errorClassList }}"
    />
  </div>
</div>
